import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { openDialog, hideDialog, setSaveState } from '../../actions';
import { addItvDeMaquina, removeItvDeMaquina, modifyItvMaquina } from '../../actions/maquina_itvs_actions';



const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});


class MaquinaItv extends React.Component {


    addItv = (itv) => {
        this.props.setSaveState(true);
        this.props.addItvDeMaquina(itv);
    };

    modifyItvMaquina = (itv) => {
        this.props.setSaveState(true);
        this.props.modifyItvMaquina(itv);
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkItv = (itv) => {

        if ((itv.fechaCaducidad < '1900-01-01T00:00:00') || !itv.fechaCaducidad) {
            this.messageDialog('Fecha inválida');
            return false;
        }

        else return true;
    };


    newItv = () => {

        this.props.openDialog('EditItvMaquina', {
            itv: {},
            maquinaId: this.props.id,
            okHandler: this.addItv,
            checkItv: this.checkItv,
        }, uuidv4());

    };

    editItv = (itv) => {

        this.props.openDialog('EditItvMaquina', {
            itv,
            maquinaId: this.props.id,
            okHandler: this.modifyItvMaquina,
            checkItv: this.checkItv
        }, uuidv4());

    };

    removeItv = (itv, index) => {
        this.props.setSaveState(true);
        this.props.removeItvDeMaquina(itv);
    };


    render() {

        const { classes } = this.props;

        return (<div >
            <Typography variant="h6" className={classes.title} color={'primary'}>ITVs</Typography>

            {this.props.maquinaItvs && !this.props.isLoading ?
                <NeuriteGrid
                    id="m_i"
                    columns={[
                        { key: 'fechaCaducidad', name: 'Fecha Caducidad', editable: false, dragable: false, type: 'date', width: 115 },

                    ]}
                    rows={this.props.maquinaItvs}
                    buttonEdit={true}
                    buttonDelete={true}
                    buttonNew={true}
                    onNewRowClick={this.newItv}
                    onEditClick={this.editItv}
                    onDeleteClick={this.removeItv}
                    height={200}
                />
                : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
        </div>
        );
    };
};

MaquinaItv.propTypes = {
    //state
    isLoading: PropTypes.bool.isRequired,
    maquinaItvs: PropTypes.array.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    addItvDeMaquina: PropTypes.func.isRequired,
    modifyItvMaquina: PropTypes.func.isRequired,
    removeItvDeMaquina: PropTypes.func.isRequired,
    //props:
    id: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        maquinaItvs: state.maquinaItvs.maquinaItvs,
        isLoading: state.maquinaItvs.isLoading,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        addItvDeMaquina,
        removeItvDeMaquina,
        modifyItvMaquina,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MaquinaItv));